import { AssetAttributes } from '@/types'
import { UpdateAssetMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { EditAssetQuery } from './__generated__/edit_query'
import { Query as EditQuery } from './edit_query'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'
import { ErrorMessage, Field, Label } from '../base/fieldset'
import { Selector as LocationSelector } from '@/components/warehouse/location/selector'
import { useContext } from 'react'
import { CurrentTenantContext } from '@/core/current_tenant_context'

type Asset = EditAssetQuery['assets']['nodes'][0]

interface Props {
  id: string
}

export const Form = ({ id }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading,
    setAttributes,
    attributes,
    fieldErrors
  } = useForm<UpdateAssetMutation, AssetAttributes, EditAssetQuery, Asset>({
    id,
    initializer: asset => ({
      warehouseId: asset.warehouse?.id || '',
      assetCaseId: asset.assetCase?.id || '',
      assetTypeId: asset.assetType?.id || '',
      serialNumber: asset.serialNumber || '',
      warehouseLocation: asset.warehouseLocation || '',
      notes: asset.notes || '',
      mystroTestId: asset.mystroTestId || ''
    }),
    query: EditQuery,
    queryKey: 'assets',
    mutation: UpdateMutation,
    resultKey: 'updateAsset'
  })
  const { currentCompany } = useContext(CurrentTenantContext)

  if (queryLoading) return <Loading />

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        { formBuilder.buildField({ name: 'Serial Number', field: 'serialNumber', type: 'text' }) }
        { currentCompany?.mystroEnabled && formBuilder.buildField({ name: 'Mystro test', field: 'mystroTestId', type: 'mystro-test' }) }
        { formBuilder.buildField({ name: 'Warehouse', field: 'warehouseId', type: 'warehouse' }) }

        { attributes.warehouseId != '' && <Field>
          <Label>Warehouse location</Label>
          <LocationSelector
            invalid={!!fieldErrors?.warehouseLocation}
            value={attributes.warehouseLocation}
            warehouseId={attributes.warehouseId}
            onChange={value => {
              setAttributes({ ...attributes, warehouseLocation: value?.id || '' })
            }}
          />
          { fieldErrors?.warehouseLocation && <ErrorMessage>{ fieldErrors?.warehouseLocation }</ErrorMessage> }
        </Field> }

        { formBuilder.buildField({ name: 'Notes', field: 'notes', type: 'textarea' }) }
        { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
      </div>
    </>
  )
}
